import script from "./RedeMarketingHome.vue?vue&type=script&setup=true&lang=js"
export * from "./RedeMarketingHome.vue?vue&type=script&setup=true&lang=js"

import "./RedeMarketingHome.vue?vue&type=style&index=0&id=868055d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-868055d4"]])

export default __exports__